smart-grid-cell {
  display: flex;
}
